import {useState} from 'react';
import {commitTicketingMutation} from '../../../graphql/forecastRelay';
import LinkForecastTaskToTicketMutation from '../../../../../mutations/ticketing/tickets/linkForecastTaskToTicketMutation';

export interface LinkForecastTaskInput {
	ticketId: string;
	forecastTaskId: string;
}

export function useLinkForecastTaskToTicket() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	function submit(input: LinkForecastTaskInput) {
		setError(null);
		setLoading(true);
		return new Promise((resolve, reject) => {
			commitTicketingMutation(
				LinkForecastTaskToTicketMutation,
				input,
				response => {
					setLoading(false);
					resolve(response.linkForecastTaskToTicket.ticket);
				},
				err => {
					setLoading(false);
					setError(err instanceof Error ? err.message : String(err));
					reject(err);
				}
			);
		});
	}

	return {submit, loading, error};
}
